/* eslint-disable react/no-danger */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CountUp from 'react-countup';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import './StatBoxes.scss';
import {fieldObjectSectionStyleCss} from "../../helpers/createStyles";
import {fieldObjectSectionStyle} from "../../helpers/graphQLShortcuts";
import {filterHeadline, filterHTML} from "../../helpers/filters";

const GET_STATBOXES = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentStatsBoxes {
          fieldStatsSectionHeader {
              entity {
                ... on Paragraph {
                  ... on ParagraphInnerSectionHeader {
                    fieldTxtHeadline
                    fieldHtmlBody {
                      value
                      format
                      processed
                    }
                    fieldVarTextAlignment
                  }
                }
              }
          }
          fieldStatBoxAlignment
          fieldStatBoxes {
              entity {
                ... on Paragraph {
                  ... on ParagraphInnerStatBox {
                    fieldTopLabel
                    fieldTopLabelColor
                    fieldTopLabelStyle
                    fieldVarTopColor
                    fieldTxtSubTitle
                    fieldLabelStyle
                    fieldTextColor
                    fieldStatPrefix
                    fieldStatSuffix
                    fieldStatNumber
                  }
                }
              }
          }
          fieldStatsSectionStyle {
                ${fieldObjectSectionStyle}
          }
        }
      }
    }
  }
}
`;

class StatBoxes extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        markComponentLoadedAs: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.statBoxOuter = React.createRef();
    }

    state = {
        allComponentsLoaded: false,
        scrolledPast: false
    }

    componentDidMount() {
        window.addEventListener('scroll', this.determineIfStatBoxIsVisible);
        document.addEventListener('DOMContentLoaded', this.handleComponentsLoaded);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.determineIfStatBoxIsVisible);
        document.removeEventListener('DOMContentLoaded', this.handleComponentsLoaded);
    }

    handleComponentsLoaded = () => {
        if (!this.state.allComponentsLoaded) {
            this.setState({allComponentsLoaded: true});
        }
    };

    determineIfStatBoxIsVisible = () => {
        if (!this.state.scrolledPast && this.statBoxOuter && this.statBoxOuter.current) {
            const { clientHeight } = this.statBoxOuter.current;

            const statBoxTop = this.statBoxOuter.current.getBoundingClientRect().top;
            const elementIsPartiallyVisible =  (statBoxTop + (clientHeight / 2)) >= 0 && (statBoxTop + (clientHeight / 2)) <= window.innerHeight;

            if (elementIsPartiallyVisible) {
                this.setState({scrolledPast: true});
            }
        }
    }

    render() {
        const {id, markComponentLoadedAs} = this.props;

        return (
            <Query asyncMode query={GET_STATBOXES} variables={{ id }}>
                {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) {
                        markComponentLoadedAs(id, true);
                        return <div>{error}</div>;
                    }

                    const field = data.paragraphById;

                    const header = field.fieldStatsSectionHeader ? field.fieldStatsSectionHeader.entity : null;
                    const statBoxes = field.fieldStatBoxes && field.fieldStatBoxes.length ? field.fieldStatBoxes : null;
                    const styles = fieldObjectSectionStyleCss(field.fieldStatsSectionStyle);
                    const statBoxAlignment = field.fieldStatBoxAlignment ? field.fieldStatBoxAlignment : 'center';

                    markComponentLoadedAs(id, true);

                    this.determineIfStatBoxIsVisible();

                    return (
                        <div className={`statBoxes${styles.classNames}`} style={styles.css} id={styles.id} ref={this.statBoxOuter}>
                            {styles.childBackground.isActive && (
                                <div style={styles.childBackground.css}/>
                            )}
                            <div className="container">

                                {header && ((header.fieldTxtHeadline) || (header.fieldHtmlBody && header.fieldHtmlBody.processed)) && (
                                    <div className="statBoxes__header">
                                        {header.fieldTxtHeadline && (
                                            // eslint-disable-next-line react/no-danger
                                            <h2 style={{textAlign: header.fieldVarTextAlignment}}
                                                dangerouslySetInnerHTML={{__html: filterHeadline(header.fieldTxtHeadline)}} />
                                        )}

                                        {header.fieldHtmlBody && header.fieldHtmlBody.processed && (
                                            // eslint-disable-next-line react/no-danger
                                            <div style={{textAlign: header.fieldVarTextAlignment}}
                                                 dangerouslySetInnerHTML={{__html: filterHTML(header.fieldHtmlBody.processed)}}/>
                                        )}
                                    </div>
                                )}

                                {statBoxes.length ? statBoxes.map(statBox => (
                                    <div className="statBox" style={{textAlign: statBoxAlignment}}>

                                        {statBox.entity && statBox.entity.fieldTopLabel ? (() => {
                                            const labelStyle = statBox.entity.fieldTopLabelStyle || 'copy';

                                            if (labelStyle === 'h3') return (
                                                <h3 className="statBox__upperLabel" style={{color: statBox.entity.fieldTopLabelColor}}>
                                                    {statBox.entity.fieldTopLabel}
                                                </h3>
                                            );

                                            if (labelStyle === 'copy' || labelStyle === 'p') return (
                                                <p className="statBox__upperLabel" style={{color: statBox.entity.fieldTopLabelColor}}>
                                                    {statBox.entity.fieldTopLabel}
                                                </p>
                                            );

                                            return null;
                                        })() : null}

                                        <h3 className="statBox__title" style={{color: statBox.entity.fieldVarTopColor}}>
                                            {statBox.entity.fieldStatPrefix}<CountUp end={this.state.scrolledPast ? statBox.entity.fieldStatNumber : 0} duration={2}/>{statBox.entity.fieldStatSuffix}
                                        </h3>

                                        {statBox.entity && statBox.entity.fieldTxtSubTitle ? (() => {
                                            const labelStyle = statBox.entity.fieldLabelStyle || 'copy';

                                            if (labelStyle === 'h3') return (
                                                <h3 className="statBox__description" style={{color: statBox.entity.fieldTextColor}}>
                                                    {statBox.entity.fieldTxtSubTitle}
                                                </h3>
                                            );

                                            if (labelStyle === 'copy' || labelStyle === 'p') return (
                                                <p className="statBox__description" style={{color: statBox.entity.fieldTextColor}}>
                                                    {statBox.entity.fieldTxtSubTitle}
                                                </p>
                                            );

                                            return null;
                                        })() : null}

                                    </div>
                                )) : null}

                            </div>
                        </div>
                    );
                }}
            </Query>
        )
    }
}

export default StatBoxes;



// WEBPACK FOOTER //
// ./frontend/components/StatBoxes/StatBoxes.jsx